import React from 'react';
import { Box } from '@mui/material';

interface CalendarContainerProps {
  children: React.ReactNode;
  height?: string | number;
}

const CalendarContainer: React.FC<CalendarContainerProps> = ({
  children,
  height = '100%'
}) => {
  return (
    <Box
      sx={{
        height,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        borderRadius: 4,
        overflow: 'auto',
        position: 'relative',
      }}
    >
      {children}
    </Box>
  );
};

export default CalendarContainer;